import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import UserName from '../Commons/UserName'
import Navigation from '../Home/Navigation'
import './Draft.css'
import { ImageMemo } from '../Game/Components/Memos'
import { useLanguageContext } from '../Commons/Translations/languageContext'
import cardsData from '../Commons/Data/cards.json'
import { useHorizontalScroll, uuidv4, getCardFromCardData } from '../QRCodeRecognition/Functions'
import { CSSTransition } from 'react-transition-group'
import Button from '../Commons/Buttons'
import { Card } from 'react-bootstrap'
import LanguageSelect from '../Commons/Translations/LanguageSelect'
import DarkMode from '../Commons/DarkMode/DarkMode'
import { DraggedCard } from '../VirtualDeck/VirtualBoard'
import { ZoomedCard } from '../Game/GameReborn'
import FullScreenPanel from '../Commons/FullScreenPanel'
import { virtualBoardDefault } from '../Game/Components/GameDefaults'
import Resizable from '../Commons/Resizable'
import { doc, setDoc } from 'firebase/firestore'
import { db } from '../Commons/Firebase'

export default function Draft(props) {
    const [isDraftComplet, setIsDraftComplete] = useState(false)
    const [cardsPicked, setCardsPicked] = useState([])

    useEffect(() => {
        const unload = async (e) => {
            e.preventDefault()
            return (e.returnValue = 'Are you sure you want to close?')
        }
        window.addEventListener('beforeunload', unload)
        return () => {
            window.removeEventListener(
                'beforeunload',
                unload,
            );
        };
    }, [])

    if (!isDraftComplet && props.turnOrder) {
        return (<DraftPanel isHost={props.isHost} globalData={props.globalData} playersData={props.playersData} sendDataToOpponents={props.sendDataToOpponents} playerId={props.playerId} turnOrder={props.turnOrder} cardsPicked={cardsPicked} setCardsPicked={setCardsPicked} setIsDraftComplete={setIsDraftComplete} />)
    }
    return (<DraftDeckBuild cardsPicked={cardsPicked} />)
}

function DraftDeckBuild(props) {
    const { t, i18n } = useLanguageContext()
    const [deckList, setDeckList] = useState([])
    const [deckLength, setDeckLength] = useState(0)
    const [rubbish, setRubbish] = useState([])
    const [cardDragged, setCardDragged] = useState(false)
    const [cardZoomed, setCardZoomed] = useState(false)
    const scrollRef = useHorizontalScroll();
    const factions = ["AXIOM", "BRAVOS", "LYRA", "MUNA", "ORDIS", "YZMIR"]
    const [deckFactions, setDeckFactions] = useState({
        AXIOM: false,
        BRAVOS: false,
        LYRA: false,
        MUNA: false,
        ORDIS: false,
        YZMIR: false,
        count: 0
    })
    const [factionFilter, setFactionFilter] = useState(false)
    const [typeFilter, setTypeFilter] = useState(false)
    const [showExportPanel, setShowExportPanel] = useState(false)
    const [deckListExport, setDeckListExport] = useState("")
    const [heroCount, setHeroCount] = useState(0)

    useLayoutEffect(() => {
        let newFactions = {
            AXIOM: false,
            BRAVOS: false,
            LYRA: false,
            MUNA: false,
            ORDIS: false,
            YZMIR: false,
            count: 0
        }
        deckList.forEach((c) => {
            if (!newFactions[c.card.faction]) {
                newFactions[c.card.faction] = true
                newFactions.count += 1
            }
        })
        setDeckFactions(newFactions)

        let newDeckLength = 0
        deckList.forEach((c) => {
            if (c.count) {
                newDeckLength += c.count
            } else {
                newDeckLength += 1
            }
        })
        setDeckLength(newDeckLength)

        let tmp = []
        deckList.forEach((c) => {
            tmp.push({ count: c.count, cardRef: c.card.id })
        })
        let str = ""
        tmp.forEach((c) => {
            str += c.count + " " + c.cardRef + "\n"
        })
        let manaConvergenceCount = 30 - newDeckLength
        if (manaConvergenceCount > 0) {
            str += manaConvergenceCount + " ALT_CORE_B_NE_1_C\n"
        }
        setDeckListExport(str)

        let hCount = 0
        deckList.forEach((c) => {
            if (c.card.type == "HERO") {
                hCount += c.count
            }
        })
        setHeroCount(hCount)
    }, [deckList])

    useEffect(() => {
        // Keep in the deck the 3 main factions
        let factionsCount = {
            BRAVOS: 0,
            AXIOM: 0,
            MUNA: 0,
            LYRA: 0,
            ORDIS: 0,
            YZMIR: 0
        }
        props.cardsPicked.forEach((c) => {
            factionsCount[c.faction] += 1
        })
        let sortable = [];
        for (var f in factionsCount) {
            sortable.push([f, factionsCount[f]]);
        }
        sortable.sort(function (a, b) {
            return a[1] - b[1];
        });
        let top3Factions = [sortable[5][0], sortable[4][0], sortable[3][0]]

        let tmpRubbish = []
        let tmpDecklist = []
        props.cardsPicked.forEach((c) => {
            if (top3Factions.includes(c.faction)) {
                addToCardArray(tmpDecklist, c)
            } else {
                addToCardArray(tmpRubbish, c)
            }
        })

        setNewRubbish(tmpRubbish)
        updateDeckList(tmpDecklist)
    }, [])

    const addToCardArray = (arr, card) => {
        let index = arr.findIndex(e => e.card.id == card.id)
        if (index >= 0) {
            arr[index].count += 1
        } else {
            let c = { ...card }
            c.cardId = uuidv4()
            arr.push({ count: 1, card: c })
        }
    }

    const updateDeckList = (newDeckList) => {
        let tmp = [...newDeckList]
        tmp.sort((a, b) => a.card.name.localeCompare(b.card.name));
        setDeckList(tmp)
    }

    const dropCard = (destination) => {
        if (!cardDragged) { return }
        if (destination != cardDragged.source) {
            if (destination == "rubbish") {
                let tmp = [...rubbish]
                addToCardArray(tmp, cardDragged.card)
                setNewRubbish(tmp)

                let tmp2 = [...deckList]
                let index = tmp2.findIndex(e => e.card.id == cardDragged.card.id)
                if (index >= 0) {
                    tmp2[index].count -= 1
                    if (tmp2[index].count <= 0) {
                        tmp2.splice(index, 1)
                    }
                }
                updateDeckList(tmp2)
            } else if (destination == "decklist") {
                let tmp = [...deckList]
                addToCardArray(tmp, cardDragged.card)
                updateDeckList(tmp)

                let tmp2 = [...rubbish]
                let index = tmp2.findIndex(e => e.card.id == cardDragged.card.id)
                if (index >= 0) {
                    tmp2[index].count -= 1
                    if (tmp2[index].count <= 0) {
                        tmp2.splice(index, 1)
                    }
                }
                setNewRubbish(tmp2)
            }
        }

        setCardDragged(false)
    }

    const setNewRubbish = (newRubbish) => {
        newRubbish.sort((a, b) => a.card.name.localeCompare(b.card.name));
        setRubbish(newRubbish)
    }

    return (<div class={"draft-panel"} >
        <div class="background-wrapper" onPointerUp={() => setCardDragged(false)}>
            <div class="blurred-background"></div>
        </div>
        <Navigation hidePromo={true} />

        <div class={"deck-build" + (cardDragged ? " waiting-selection" : "") + (factionFilter ? " faction-filter " + factionFilter.join(" ") : "") + (typeFilter ? " type-filter " + typeFilter.join(" ") : "")} >
            <div class="deck-rubbish" onPointerUp={() => dropCard("rubbish")} >
                <h2 class="drop-info-message">{t("draft.remove")}</h2>
                <div ref={scrollRef} class="side-scroll h-100 d-flex flex-row align-items-center">
                    {
                        rubbish.map((c, i) => {
                            return (<DraftCard card={c} cardDragged={cardDragged}
                                key={c.card.cardId}
                                setCardZoomed={setCardZoomed}
                                onpointerdown={() => {
                                    setCardDragged({ source: "rubbish", card: c.card, index: i })
                                }} />)
                        })
                    }
                </div>
            </div>

            <Resizable className="light-shadowed">
                <div class={"deck-list position-relative"} onPointerUp={() => dropCard("decklist")} >
                    <div class="blurred-background"></div>
                    <h2 class="drop-info-message">{t("draft.add")}</h2>
                    <div class="cards-list-wrapper hide-scrollbar w-100 h-100 overflow-y-scroll">
                        <div class="cards-list row row-cols-7">
                            {[0, 1, 2, 3, 4, 5, 6].map((v) => {
                                if (v == 6) {
                                    return (<div class="col">
                                        {deckList.map((c, i) => {
                                            if (c.card.manaCost[0] >= v) {
                                                return (<DraftCard card={c} cardDragged={cardDragged}
                                                    key={c.card.cardId}
                                                    setCardZoomed={setCardZoomed}
                                                    onpointerdown={() => {
                                                        setCardDragged({ source: "decklist", card: c.card, index: i })
                                                    }} />)
                                            }
                                        })}
                                    </div>)
                                } else {
                                    return (<div class="col">
                                        {deckList.map((c, i) => {
                                            if (c.card.manaCost[0] == v) {
                                                return (<DraftCard card={c} cardDragged={cardDragged}
                                                    key={c.card.cardId}
                                                    setCardZoomed={setCardZoomed}
                                                    onpointerdown={() => {
                                                        setCardDragged({ source: "decklist", card: c.card, index: i })
                                                    }} />)
                                            }
                                        })}
                                    </div>)
                                }
                            })}
                        </div>
                    </div>
                    <div class="box-blurred w-100 deck-info position-absolute d-flex flex-row align-items-center top-0 left-0">
                        <p class="fw-bold">{t("draft.your_deck")}:</p>
                        <p class="fw-bold">{deckLength}/30</p>
                        {deckLength < 30 && (<p class="">+ {30 - deckLength} mana</p>)}
                        <div class="banners d-flex flex-row align-items-center ms-5">
                            {factions.map((f) => {
                                return (<img class={(deckFactions[f] ? " present" : " absent") + (factionFilter && factionFilter.includes(f) ? " is-filter" : "")} src={require('./Assets/' + f + '-faction-banner.png')}
                                    onClick={() => {
                                        if (!factionFilter) { setFactionFilter([f]); return }
                                        let index = factionFilter.findIndex(x => x === f)
                                        if (index >= 0) {
                                            let n = factionFilter.filter(x => x !== f)
                                            if (n.length == 0) {
                                                setFactionFilter(false)
                                            } else {
                                                setFactionFilter(n)
                                            }
                                        } else {
                                            let n = [...factionFilter]
                                            n.push(f)
                                            setFactionFilter(n)
                                        }
                                    }}
                                />)
                            })}
                        </div>
                        <div class="d-flex flex-row align-items-center types-filters">
                            {["HERO", "CHARACTER", "SPELL", "PERMANENT"].map((ty) => {
                                return (<Button class="tertiary no-shadow" selected={typeFilter && typeFilter.includes(ty)} onClick={() => {
                                    if (!typeFilter) { setTypeFilter([ty]); return }
                                    let index = typeFilter.findIndex(x => x === ty)
                                    if (index >= 0) {
                                        let n = typeFilter.filter(x => x !== ty)
                                        if (n.length == 0) {
                                            setTypeFilter(false)
                                        } else {
                                            setTypeFilter(n)
                                        }
                                    } else {
                                        let n = [...typeFilter]
                                        n.push(ty)
                                        setTypeFilter(n)
                                    }
                                }}>
                                    {t("commons.types." + ty)} ({deckList.filter((c) => c.card.type == ty).length})
                                </Button>)
                            })}
                        </div>
                        <div class="ms-auto d-flex flex-row">
                            {deckFactions.count <= 3 && heroCount <= 1 && (<Button onClick={() => setShowExportPanel(true)}>{t("draft.end")}</Button>)}
                            {deckFactions.count > 3 && (<p class="ms-auto">{t("draft.factions_limit")}</p>)}
                            {heroCount > 1 && (<p>{t("draft.hero_limit")}</p>)}
                        </div>
                    </div>
                </div>
            </Resizable>
        </div>
        <div class="participants d-flex flex-row">
            <div class="nav-items d-flex flex-row">
                <LanguageSelect />
                <DarkMode />
            </div>
        </div>
        <div class={cardDragged ? "opacity-0" : ""}>
            <ZoomedCard zoomedVirtualCard={cardZoomed} widthVh={35} />
        </div>
        <DraggedCard cardDragged={cardDragged} />
        {showExportPanel && (<FullScreenPanel title={t("game.menu.button_leave.pannel_title")} component={
            <ExportPanelContent deckListExport={deckListExport} deckList={deckList} />
        } hidePanel={() => setShowExportPanel(false)} />)}
    </div >)
}

function ExportPanelContent(props) {
    const { t, i18n } = useLanguageContext()
    const [saveFeedback, setSaveFeedback] = useState(false)
    const validationCode = "etzzerjij8heHRzehr9bfhdsbfhseb7fhebfrsy8"

    const saveDeckList = () => {
        let deckList = []
        let deckLength = 0
        props.deckList.forEach((c) => {
            if (c.count) {
                deckLength += c.count
            } else {
                deckLength += 1
            }
        })

        for (let i = 0; i < props.deckList.length; i++) {
            for (let j = 0; j < props.deckList[i].count; j++) {
                let c = { ...props.deckList[i].card }
                c.cardId = uuidv4() + "i"
                deckList.push(c)
            }
        }
        if (deckLength < 30) {
            let missingCards = 30 - deckLength
            let mana = getCardFromCardData(cardsData["ALT_CORE_B_NE_1_C"], i18n.language)
            for (let i = 0; i < missingCards; i++) {
                let c = { ...mana }
                c.cardId = uuidv4() + "mana" + i
                deckList.push(c)
            }
        }

        let newData = JSON.parse(JSON.stringify(virtualBoardDefault))
        newData.deckList = [...deckList]

        let item = window.localStorage.getItem("board-data")
        if (item) {
            let oldData = JSON.parse(item)
            newData = { ...oldData }
            newData.deckList = [...deckList]
            newData.source = "deck-tester"
        }

        window.localStorage.setItem("board-data", JSON.stringify(newData));
    }

    const updateValidationCode = () => {
        // String containing card pool of all the drafters
    }



    return (<div class="d-flex flex-column">
        <div class="row">
            <div class="col-6 d-flex flex-column">
                <h2 class="mb-4">Decklist</h2>
                <div class="d-flex flex-column deck-list-export">
                    <p class="m-0">{props.deckListExport}</p>
                </div>
            </div>
            <div class="col-6 d-flex flex-column justify-content-start">
                {/*
                                <h2 class="mb-4">Play</h2>
                <Button class="my-4" onClick={() => {
                    saveDeckList();
                    setSaveFeedback(true)
                    setTimeout(() => {
                        setSaveFeedback(false)
                    }, 2000);
                }}>{saveFeedback ? "Saved !" : "Save deck for Exalts Table"}</Button>
                <p>To play with your deck, press the button above, then <a href="/play" target="_blank">find or create a lobby</a> in the game mode of your choice. Choose "Virtual" and your deck will be there.</p>
                <p>Keep this tab open to make changes to your deck. Press the button above again to update the decklist. Don't be afraid to make changes while playing, your deck is only gonna be updated at the start of a new round.</p>
                */}
                {/*
<h2 class="mb-4">Decklist checking</h2>
                <p>If someone wants to verify your decklist, send him this code with your decklist.</p>
                <div class="d-flex flex-row input-with-button deck-list-export">
                    <p class="mx-auto">{validationCode}</p>
                </div>
            */}

            </div>
        </div>
    </div>)
}

function DraftCard(props) {
    const { i18n } = useLanguageContext()
    const [isDragging, setIsDragging] = useState(false)

    useEffect(() => {
        if (!props.cardDragged) {
            setIsDragging(false)
        }
    }, [props.cardDragged])

    return (<CSSTransition key={props.card.card.cardId} timeout={700} classNames="item">
        <div class={"card-picked animated-glow " + (isDragging ? " opacity-0" : "") + (" " + props.card.card.faction + " " + props.card.card.type) + (props.className ? " " + props.className : "") + (props.card.count > 1 ? " stacked" : "")}>
            <div
                onPointerDown={() => {
                    setIsDragging(true)
                    props.onpointerdown()
                }}
                onPointerUp={() => setIsDragging(false)}
                onMouseEnter={() => props.setCardZoomed(props.card.card)}
                onMouseLeave={() => props.setCardZoomed(false)}>
                <ImageMemo src={props.card.images ? props.card.images[i18n.language] : props.card.card.image} />
                {props.card.count > 1 && (<h3 class="position-absolute draft-card-count">x{props.card.count}</h3>)}
            </div>
        </div>
    </CSSTransition>)
}

function DraftPanel(props) {
    const { t, i18n } = useLanguageContext()
    const [isOpening, setIsOpening] = useState(false)
    const [currentPack, setCurrentPack] = useState([])
    const [remainingBoosters, setRemainingBoosters] = useState([...props.globalData.gameModeInfo.draftBoostersSets])
    const [switchingAnimationProgress, setSwitchingAnimationProgress] = useState(false)
    const [previousPlayerId, setPreviousPlayerId] = useState(0)
    const [isAllReady, setIsAllReady] = useState(false)
    const [showCardsPickedPanel, setShowCardsPickedPanel] = useState(false)

    const heroesRef = useRef({})
    const commonsRef = useRef({})
    const raresRef = useRef({})
    const currentStatusRef = useRef(false)
    const [cardsPickedInOrder, setCardsPickedInOrder] = useState([])

    useEffect(() => {
        let myIndex = props.turnOrder.findIndex((e) => e == props.playerId)
        if (myIndex == 0) {
            setPreviousPlayerId(props.turnOrder[props.turnOrder.length - 1])
        } else {
            setPreviousPlayerId(props.turnOrder[myIndex - 1])
        }

        // ini
        if (!heroesRef.current["BTG"]) {
            var keys = Object.keys(cardsData);
            keys.forEach((k) => {
                let c = cardsData[k]
                let set = "KS"
                if (c.id.includes("CORE_B")) {
                    set = "BTG"
                } else if (c.id.includes("ALIZE")) {
                    set = "TBF"
                } else if (c.id.includes("BISE")) {
                    set = "WFM"
                }
                if (set != "KS") {
                    if (c.type == "HERO") {
                        if (!heroesRef.current[set]) {
                            heroesRef.current[set] = []
                        }
                        heroesRef.current[set].push(getCardFromCardData(c, i18n.language))
                    } else if (c.rarity == "RARE") {
                        if (!raresRef.current[set]) {
                            raresRef.current[set] = []
                        }
                        raresRef.current[set].push(getCardFromCardData(c, i18n.language))
                    } else if (c.rarity == "COMMON") {
                        let com = getCardFromCardData(c, i18n.language)
                        if (com.faction != "NONE" && com.type != "TOKEN") {
                            if (!commonsRef.current[set]) {
                                commonsRef.current[set] = {
                                    AXIOM: [],
                                    BRAVOS: [],
                                    MUNA: [],
                                    LYRA: [],
                                    ORDIS: [],
                                    YZMIR: []
                                }
                            }
                            commonsRef.current[set][com.faction].push(com)
                        }
                    }
                }
            })
        }

        if (!props.isHost) {
            setTimeout(() => {
                stayinAlive()
            }, 2000)
        }

    }, [])

    const stayinAlive = () => {
        if (currentStatusRef.current) {
            let data = { ...currentStatusRef.current }
            data.currentPack = [...currentStatusRef.current.currentPack]
            props.sendDataToOpponents({ player: { ...data } })
        }

        setTimeout(() => {
            stayinAlive()
        }, 2000)
    }

    useEffect(() => {
        if (props.isHost) {
            if (isAllReady) { return }
            let allReady = true
            for (let i = 0; i < props.turnOrder.length; i++) {
                if (!props.playersData[props.turnOrder[i]].isReady) {
                    allReady = false
                }
            }
            setIsAllReady(allReady)
        }
    }, [props.playersData, props.playersData[props.playerId]])

    useEffect(() => {
        if (isAllReady && props.isHost) {
            let playersPack = {}
            // Pour chaque joueur, je met à jour le pack
            // Je les envoies sur global

            Object.entries(props.playersData).forEach(([k, v]) => {
                playersPack[k] = [...v.currentPack]
            })

            playersPack.round = (props.globalData.playersPack && props.globalData.playersPack.round) ? props.globalData.playersPack.round + 1 : 1
            let gData = { ...props.globalData }
            gData.playersPack = { ...playersPack }
            props.sendDataToOpponents({ global: gData })

            setTimeout(() => {
                setIsAllReady(false)
            }, 1000)
        }
    }, [isAllReady])

    const [round, setRound] = useState(0)

    useEffect(() => {
        if (!props.globalData.playersPack) { return }
        // seulment si nouveau round
        if (round >= props.globalData.playersPack.round) { return }
        setRound(props.globalData.playersPack.round)
        const newPack = props.globalData.playersPack[previousPlayerId]
        if (newPack.length <= 0) {
            if (remainingBoosters.length == 1) {
                // FINISH
                props.setIsDraftComplete(true)
                if (cardsPickedInOrder.length >= 48 && props.turnOrder.length > 1) {
                    let draftCardsData = []
                    cardsPickedInOrder.forEach((c) => {
                        draftCardsData.push(c.rarity[0] + " " + c.type + " " + c.faction + " " + c.manaCost[0] + "/" + c.manaCost[1] + " " + c.power[0] + "-" + c.power[1] + "-" + c.power[2] + " " + c.name + " " + c.id)
                    })
                    setDoc(doc(db, "draft-data", uuidv4()), {
                        date: new Date(),
                        booster1: draftCardsData.slice(0, 12),
                        booster2: draftCardsData.slice(12, 24),
                        booster3: draftCardsData.slice(24, 36),
                        booster4: draftCardsData.slice(36, 48)
                    });
                }
            } else {
                setRemainingBoosters(remainingBoosters.slice(1, remainingBoosters.length))
                // CHANGE ORDER
                let myIndex = props.turnOrder.findIndex((e) => e == props.playerId)
                if (remainingBoosters.length % 2 == 0) {
                    if (myIndex == props.turnOrder.length - 1) {
                        setPreviousPlayerId(props.turnOrder[0])
                    } else {
                        setPreviousPlayerId(props.turnOrder[myIndex + 1])
                    }
                } else {
                    if (myIndex == 0) {
                        setPreviousPlayerId(props.turnOrder[props.turnOrder.length - 1])
                    } else {
                        setPreviousPlayerId(props.turnOrder[myIndex - 1])
                    }
                }
            }
            setCurrentPack([])
            setIsOpening(false)
            setSwitchingAnimationProgress(false)
        } else {
            setCurrentPack([...newPack])
            setTimeout(() => {
                setSwitchingAnimationProgress("entering")
            }, 200)
            setTimeout(() => {
                setSwitchingAnimationProgress("entered")
            }, 1300)
        }
        let myData = { ...props.playersData[props.playerId] }
        myData.isReady = false
        props.sendDataToOpponents({ player: myData })
        currentStatusRef.current = myData
    }, [props.globalData.playersPack])

    const openPack = () => {
        setIsOpening(true)
        let currentSet = remainingBoosters[0]
        let newPackTmp = []

        newPackTmp.push({ ...heroesRef.current[currentSet][Math.floor(Math.random() * heroesRef.current[currentSet].length)] })

        const randomPercentage = () => {
            return Math.round(Math.random() * 99) + 1
        }

        let commonsFactions = []

        // COMMON 0
        let percentage = randomPercentage()
        commonsFactions.push(percentage <= 50 ? "AXIOM" : "BRAVOS")

        // COMMON 1
        commonsFactions.push(commonsFactions[0] == "AXIOM" ? "BRAVOS" : "AXIOM")

        // COMMON 2
        percentage = randomPercentage()
        commonsFactions.push(percentage <= 50 ? (commonsFactions[1] == "AXIOM" ? "BRAVOS" : "AXIOM") : (percentage <= 75 ? "MUNA" : "LYRA"))

        // COMMON 3
        percentage = randomPercentage()
        commonsFactions.push(percentage <= 50 ? "MUNA" : "LYRA")

        // COMMON 4
        percentage = randomPercentage()
        commonsFactions.push(commonsFactions[3] == "MUNA" ? "LYRA" : "MUNA")

        // COMMON 5
        // SI DEJA MUNA EN 2, FORCEMENT OR-YZ
        percentage = randomPercentage()
        commonsFactions.push(commonsFactions[2] == "MUNA" || commonsFactions[2] == "LYRA" ? (percentage <= 50 ? "ORDIS" : "YZMIR") : (percentage <= 50 ? (commonsFactions[4] == "MUNA" ? "LYRA" : "MUNA") : (percentage <= 75 ? "ORDIS" : "YZMIR")))

        // COMMON 6
        percentage = randomPercentage()
        commonsFactions.push(percentage <= 50 ? "ORDIS" : "YZMIR")

        // COMMON 7
        percentage = randomPercentage()
        commonsFactions.push(commonsFactions[6] == "YZMIR" ? "ORDIS" : "YZMIR")

        // SWAP 3-4 AND 6-7 IF SAME FACTION IN A ROW
        function swapInArray(arr, i1, i2) {
            let t = arr[i1];
            arr[i1] = arr[i2];
            arr[i2] = t;
        }

        if (commonsFactions[2] == commonsFactions[3]) {
            swapInArray(commonsFactions, 3, 4)
        }
        if (commonsFactions[4] == commonsFactions[5]) {
            swapInArray(commonsFactions, 3, 4)
        }

        if (commonsFactions[5] == commonsFactions[6]) {
            swapInArray(commonsFactions, 6, 7)
        }

        let commons = { ...commonsRef.current[currentSet] }
        for (let i = 0; i < 8; i++) {
            let index = Math.floor(Math.random() * commons[commonsFactions[i]].length);
            let c = commons[commonsFactions[i]].splice(index, 1)[0];
            newPackTmp.push(c)
        }

        let rares = [...raresRef.current[currentSet]]
        for (let i = 0; i < 3; i++) {
            let index = Math.floor(Math.random() * rares.length);
            let c = rares.splice(index, 1)[0];
            newPackTmp.push({ ...c })
        }

        for (let n = 0; n < newPackTmp.length; n++) {
            newPackTmp[n].cardId = uuidv4() + "n"
        }
        setCurrentPack(newPackTmp)
    }

    const cardPicked = (card, i) => {
        if (!(switchingAnimationProgress == "entered" || switchingAnimationProgress === false)) { return }
        let tmp = [...currentPack]
        tmp[i].picked = true
        setCurrentPack(tmp)
        setSwitchingAnimationProgress("leaving")

        if (props.turnOrder.length == 1) {
            // If playing solo, take all the cards
            for (let n = 0; n < tmp.length; n++) {
                tmp[n].picked = true
            }
        }

        setTimeout(() => {
            let tmpToSend = []

            let picked = []
            for (let i = 0; i < tmp.length; i++) {
                if (!tmp[i].picked) {
                    tmpToSend.push({ ...tmp[i] })
                } else {
                    picked.push({ ...tmp[i] })
                }
            }
            if (picked.length > 0) {
                let ord = [...cardsPickedInOrder]
                picked.forEach((cp) => {
                    ord.push({ ...cp })
                })
                addToCardsPicked(picked)
                setCardsPickedInOrder(ord)
            }

            setSwitchingAnimationProgress("switching")
            let myData = { ...props.playersData[props.playerId] }
            myData.currentPack = [...tmpToSend]
            myData.isReady = true
            props.sendDataToOpponents({ player: myData })
            currentStatusRef.current = myData
        }, 1100)
    }

    const addToCardsPicked = (cards) => {
        let d = [...props.cardsPicked]
        cards.forEach((c) => {
            let card = { ...c }
            delete card.picked
            d.push(card)
        })

        d.sort((a, b) => a.faction.localeCompare(b.faction));
        props.setCardsPicked(d)
    }

    return (<div class={"draft-panel drafting" + (isOpening ? " pack-opening" : "") + (switchingAnimationProgress ? " " + switchingAnimationProgress : "")} >
        <div class="background-wrapper">
            <div class="blurred-background"></div>
        </div>
        <Navigation hidePromo={true} />
        <div class="participants d-flex flex-row">
            {props.turnOrder.map((id) => {
                let data = props.playersData[id]
                return (<UserName className={data.isReady ? "ready" : ""} name={data.userInfo.name} />)
            })}
            <div class="nav-items d-flex flex-row">
                <LanguageSelect />
                <DarkMode />
            </div>
        </div>
        <div class="draft-section">
            <div class="cards">
                {currentPack.map((c, i) => {
                    return (
                        <div key={c.cardId + i} class={"card-wrapper" + (c.rarity == "RARE" ? " rare" : "") + (c.picked ? " picked" : "")} onClick={() => cardPicked(c, i)}  >
                            <ImageMemo src={c.images ? c.images[i18n.language] : c.image} className="card" />
                            <img class="card-back" src={require('../VirtualDeck/Assets/card-back.png')} />
                            <div class="zoom-hover"></div>
                        </div>
                    )
                })}
            </div>

            <PackWrapper openPack={openPack} isOpening={isOpening} remainingBoosters={remainingBoosters} />

            {remainingBoosters.length >= 1 && (
                <div class="d-flex flex-row booster-remainings justify-content-between">
                    {remainingBoosters.map((b, i) => {
                        if (i > 0) {
                            return (<img class="booster-pack booster-remaining" src={require('./Assets/Boosters/' + b + '.png')} />)
                        }
                    })}
                </div>)}

            {props.cardsPicked && (<Button class={"cards-picked-show" + (showCardsPickedPanel ? " top" : "")} onClick={() => setShowCardsPickedPanel(!showCardsPickedPanel)}>{showCardsPickedPanel ? t("draft.hide_pick") : t("draft.see_pick")} ({props.cardsPicked.length})</Button>)}

            {!isAllReady && isOpening && props.playersData[props.playerId].isReady && (<h2 class="waiting-messgage">{t("draft.waiting_pick")}</h2>)}
            <CardsPicked showPanel={showCardsPickedPanel} cardsPicked={props.cardsPicked} />
        </div>


    </div>)
}

function PackWrapper(props) {
    const boosterSet = props.remainingBoosters.length > 0 ? props.remainingBoosters[0] : "BTGKS"
    const [cardTransform, setCardTransform] = useState({
        rotationY: 0,
        rotationX: 0,
        imgOffsetX: 0
    })/*
    const [shineValues, setShineValues] = useState({
        x: 0,
        y: 0
    })*/

    function rotateToMouse(e) {
        const card = e.currentTarget;
        const x = e.pageX - card.offsetLeft;
        const y = e.pageY - card.offsetTop;
        const px = x / card.offsetWidth;
        const py = y / card.offsetHeight;
        const xx = -15 + 30 * px;
        const yy = 15 - 30 * py;
        /*
                const center = {
                    x: e.pageX - card.offsetWidth / 2,
                    y: e.pageY - card.offsetHeight / 2
                  }
        */
        setCardTransform({
            rotationY: xx,
            rotationX: yy / 2,
            scale: 1.05
        });
        /*
                setShineValues({
                    x: center.x * 2 + card.offsetWidth / 2 + '%',
                    y: center.y * 2 + card.offsetHeight / 2 + '%'
                })*/
    }

    return (
        <div class="pack-wrapper"
            onClick={() => props.openPack()}
            onMouseMove={(e) => {
                rotateToMouse(e)
            }}
            onMouseLeave={() => {
                setCardTransform({
                    rotationY: 0,
                    rotationX: 0,
                    scale: 1
                })
            }}>
            <div class="h-100 w-100 position-absolute top-0" style={{
                transform: `perspective(1000px) rotateY(${cardTransform.rotationY}deg) rotateX(${cardTransform.rotationX}deg) scale(${cardTransform.scale})`
            }} >
                <div class="position-absolute top-50 start-50 translate-middle pe-none overflow-hidden glow"></div>

                <div class="pack-left pack-part">
                    <img class="booster-pack" src={require('./Assets/Boosters/' + boosterSet + '.png')} />
                </div>
                <div class="pack-right pack-part">
                    <img class="booster-pack" src={require('./Assets/Boosters/' + boosterSet + '.png')} />
                </div>
                <div class="position-absolute top-0 w-100 h-100 pe-none overflow-hidden">
                    <div class="pack-cut"></div>
                </div>
                {/*<div class="position-absolute top-0 w-100 h-100 pe-none overflow-hidden shine"
                    style={{background: 'radial-gradient(circle at ' + shineValues.x + ' ' + shineValues.y + ', #ffffff22, #0000000f)'}}
        ></div>*/}
            </div>
        </div>
    )
}

function CardsPicked(props) {
    const { i18n } = useLanguageContext()

    return (<div class={"cards-picked-panel w-100 h-100" + (props.showPanel ? "" : " hidden")}>
        <div class="blurred-background"></div>
        <div class="cards-picked-wrapper hide-scrollbar">
            <div class="cards-picked row row-cols-6">
                {props.cardsPicked.map((c) => {
                    return (<div class="card-picked col"><ImageMemo src={c.images ? c.images[i18n.language] : c.image} /><div class="zoom-hover"></div></div>)
                })}
            </div>
        </div>
    </div>)
}